import { render, staticRenderFns } from "./SolicitacoesDeTransferencia.vue?vue&type=template&id=25e07441&"
import script from "./SolicitacoesDeTransferencia.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesDeTransferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports